import { EnvConfig } from './env-config.interface';
import { environmentBase } from './environment.base';


export const environment: EnvConfig = Object.assign(
  environmentBase,
  {
    ENV: 'PROD',
    API: 'https://pxm.partshub.com:8443/api',
    BACKEND: 'https://pxm.partshub.com:8443/',
    DEFAULT_PRODUCT_IMAGE: 'https://pxm.partshub.com/img/part_default_img.jpg',
    DEFAULT_ASSET_IMAGE: '/assets/img/item_default_img.jpg',
    ALLOW_NON_SUBSCRIBERS: false,
    JIRA_ID: 'db847139-cd2a-3b9b-be9f-d0cd57ed5e23',
    STRIPE_PUBLIC_KEY: 'pk_live_KdJgGuKK9LxiyBK87NohfCF8',
    ROLLBAR_KEY: 'ca037e0e70ac468dbf4706fc945a18ec',
    BUGSNAG_KEY: 'e135d69b6a1d4ab88a24a0e68a290be2',
});
